<template>
    <div class="btn-group">
        <!--Retour au formulaire vierge-->
        <button @click="onSubmit" class="btn btn-default " style="margin-right:5px;"
                :title="$t('Bareme.etape2.buttons.retourEtape1Aide')">
            {{$t('Bareme.etape2.buttons.retourEtape1')}}
        </button>
        <!-- Génération PDF-->
        <button @click="onGenererPdf" class="btn btn-primary" style="margin-right:5px;"
                :title="$t('Bareme.etape2.buttons.genererPDFAide')">
            {{$t('Bareme.etape2.buttons.genererPDF')}}
        </button>
    </div>

</template>

<script>
export default {
  name: 'section-buttons',
  props: {
    dossier: {
      type: Object,
      required: true,
    },
    onSubmit: {
      type: Function,
      required: true,
    },
    onGenererPdf: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style scoped>

</style>
